<template>
  <create-account-layout
    :current-step="2"
    title="Your Details"
  >
    <section>
      <p class="mb-6 mt-8 text-left text-sm text-dark-gray">
        Let’s get some basic information about you.
      </p>
      <div>
        <form-field
          label="Full Name"
          :value="full_name"
          placeholder="Enter full name"
          :on-input="handleFullnameUpdate"
          :error="full_name_error"
          :alert-message="full_name_alert"
          name="full_name"
        />
      </div>
      <div class="mt-6">
        <form-field
          label="Company Email"
          :value="companyEmail"
          placeholder="Enter Email"
          :on-input="handleCompanyEmailUpdate"
          :on-blur="validateCompanyEmail"
          :error="companyEmailError"
          name="company_email"
        />
      </div>
    </section>
    <button-main
      class="my-3 mb-4"
      :disabled="!isContinueEnabled()"
      :is-loading="isLoading"
      value="Continue"
      @click="handleContinue"
    >
      Continue
    </button-main>
  </create-account-layout>
</template>

<script>
import CreateAccountLayout from '@/components/layouts/CreateAccountLayout.vue';
import ButtonMain from '@/components/Button.vue';
import FormField from '@/components/FormField.vue';
import fullnameAndEmailField from '@/mixins/fullnameAndEmailField';
import { toastResponse } from '@/common/handleServerResponse';
import { formatFirstLastName } from '@/common/validators';

export default {
  name: 'YourDetails',
  components: {
    CreateAccountLayout,
    ButtonMain,
    FormField,
  },
  mixins: [fullnameAndEmailField],
  data: function () {
    return {
      companyEmail: '',
      companyEmailError: '',
      isLoading: false,
    };
  },
  computed: {
    selectedIdentifier: function () {
      return this.$store.state.identifiers.selectedIdentifier;
    },
    currentUser: function () {
      return this.$store.state.users.currentUser;
    },
  },
  created: function () {
    if (!this.currentUser) {
      return;
    }
    if (this.currentUser?.email) {
      this.companyEmail = this.currentUser?.email;
    }
    if (this.currentUser?.first_name) {
      this.full_name += this.currentUser?.first_name;
      if (this.currentUser?.last_name) {
        this.full_name += ' ' + this.currentUser?.last_name;
      }
    }
  },
  methods: {
    handleFullnameUpdate: function (e) {
      this.full_name = e.target.value;
    },
    handleCompanyEmailUpdate: function (e) {
      this.companyEmail = e.target.value;
    },
    validateCompanyEmail(e) {
      this.companyEmailError = '';
      const companyEmail = e.target?.value || e?.value || null;
      if (!companyEmail) {
        this.companyEmailError = 'This field is required.';
        return;
      }
    },
    isContinueEnabled: function () {
      return (
        this.full_name &&
        this.companyEmail &&
        !this.full_name_error_sw &&
        !this.companyEmailError
      );
    },
    handleContinue: async function () {
      if (!this.isContinueEnabled()) {
        return;
      }
      const { first_name, last_name } = formatFirstLastName(this.full_name);
      this.isLoading = true;
      const res = await this.$store.dispatch('users/patchSignUpDetails', {
        first_name,
        last_name,
        email: this.companyEmail,
      });

      if (![200, 201].includes(res.status)) {
        toastResponse(this, res, null);
        return;
      }
      await this.$store.dispatch('users/serverRefreshCurrentUser');
      this.isLoading = false;
      this.$router.push({ name: 'CompanyDetails' });
    },
  },
};
</script>

<style></style>
